import { render, staticRenderFns } from "./comp-play.vue?vue&type=template&id=aab78f7c&scoped=true&lang=pug&"
import script from "./comp-play.vue?vue&type=script&lang=js&"
export * from "./comp-play.vue?vue&type=script&lang=js&"
import style0 from "./comp-play.vue?vue&type=style&index=0&id=aab78f7c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab78f7c",
  null
  
)

export default component.exports